!function(){"use strict";
var OW=window.OW||{};
var LIMIT=10;

/* ---------- Pretraga: zajednička logika ---------- */

/* mala slova, bez kvačica (š→s, č/ć→c, ž→z, đ→d), samo slova i brojevi */
function norm(s){
  return String(s||"").toLowerCase().replace(/đ/g,"d").normalize("NFD").replace(/[̀-ͯ]/g,"").replace(/[^a-z0-9]+/g," ").trim();
}
function words(s){return norm(s).split(" ").filter(Boolean)}

function lev(a,b){
  if(a===b)return 0;
  var m=a.length,n=b.length,prev=[],cur,i,j;
  for(j=0;j<=n;j++)prev[j]=j;
  for(i=1;i<=m;i++){
    cur=[i];
    for(j=1;j<=n;j++)cur[j]=Math.min(prev[j]+1,cur[j-1]+1,prev[j-1]+(a[i-1]===b[j-1]?0:1));
    prev=cur;
  }
  return prev[n];
}

/* Da li reč iz upita odgovara nekoj reči proizvoda: početak reči, ili greška u kucanju
   od 1 slova (4 slova) odnosno 2 slova (5+). Kratke reči (rl, tn, m) ne proveravamo. */
function wordHit(q,hay){
  if(q.length<3)return true;
  var tol=q.length>=5?2:q.length===4?1:0;
  for(var i=0;i<hay.length;i++){
    var h=hay[i];
    if(h.indexOf(q)===0)return true;
    if(h.length>=4&&q.indexOf(h)===0)return true;
    if(tol&&(lev(q,h)<=tol||lev(q,h.slice(0,q.length))<=tol))return true;
  }
  return false;
}

/* Shopify pretraga toleriše greške i kod više reči vraća proizvode sa bilo kojom
   od njih, pa "gucci" vraća Hugo, a "boss duks" i Fred Perry dukseve. Ovde
   zadržavamo samo proizvode u kojima se nalazi svaka reč iz upita. */
function matches(text,q){
  var hay=words(text),qs=words(q),i;
  /* spojene susedne reči, da "nortface" nađe "The North Face" */
  for(i=hay.length-1;i>0;i--)hay.push(hay[i-1]+hay[i]);
  for(i=0;i<qs.length;i++)if(!isColor(qs[i])&&!wordHit(qs[i],hay))return false;
  return true;
}

/* Boja ne postoji u nazivu, tagovima ni opcijama proizvoda, pa je ne zahtevamo:
   "bela majica" prikazuje majice (one sa bojom u opisu idu prve). */
var COLORS=["crn","bel","plav","zelen","siv","crven","braon","bez","roz","zut","narand","ljubic","teget","bordo","krem","maslin","tamn","svetl","black","white","navy","blue","green","grey","gray","red","brown","beige","pink","yellow","orange","purple","cream","olive"];
function isColor(w){
  for(var i=0;i<COLORS.length;i++)if(w.indexOf(COLORS[i])===0&&w.length<=COLORS[i].length+3)return true;
  return false;
}

/* "boss duks" → "\"boss\" \"duks\"" (Shopify tada traži tačno te reči, sve zajedno) */
function strictQuery(q){
  return String(q).replace(/"/g," ").trim().split(/\s+/).filter(Boolean).map(function(w){return'"'+w+'"'}).join(" ");
}
function cleanQuery(q){return String(q||"").replace(/"/g," ").replace(/\s+/g," ").trim()}

/* hidden atribut ne gasi elemente sa Tailwind display klasama (flex, grid, pill) */
function show(el,on){el&&(el.style.display=on?"":"none")}

function plural(n){
  var d=n%10,dd=n%100;
  return d===1&&dd!==11?"rezultat":"rezultata";
}

window.OWSearch={norm:norm,matches:matches,strictQuery:strictQuery,cleanQuery:cleanQuery};

/* ---------- Brza pretraga (overlay) ---------- */

function img(u,w){return u?u+(u.indexOf("?")===-1?"?":"&")+"width="+w:""}
function money(p){var c=Math.round(100*parseFloat(p));return isNaN(c)?"":window.OWCart?window.OWCart.formatMoney(c):p}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]})}

function suggest(q,signal){
  var url=(OW.routes&&OW.routes.predictiveSearch||"/search/suggest")+".json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]="+LIMIT+"&resources[options][unavailable_products]=last";
  return fetch(url,{signal:signal}).then(function(r){return r.json()}).then(function(d){return d.resources&&d.resources.results&&d.resources.results.products||[]});
}
function haystack(p){return[p.title,p.vendor,p.type,(p.tags||[]).join(" ")].join(" ")}

function searchUrl(q){return(OW.routes&&OW.routes.search||"/search")+"?type=product&q="+encodeURIComponent(strictQuery(q))}

function initOverlay(){
  var root=document.querySelector('[data-overlay="search"]');
  if(!root)return;
  var input=root.querySelector("[data-search-input]"),list=root.querySelector("[data-search-results]"),
      status=root.querySelector("[data-search-status]"),line=root.querySelector("[data-search-underline]"),
      all=root.querySelector("[data-search-all]");
  if(!input||!list)return;
  var initialHtml=list.innerHTML,initialStatus=status?status.textContent:"",timer=null,ctrl=null;

  function reset(){
    list.innerHTML=initialHtml;
    if(status)status.textContent=initialStatus;
    show(all,false);
  }

  function render(items,q){
    if(!items.length){
      list.innerHTML="";
      if(status)status.textContent='Nema rezultata za "'+q+'"';
      show(all,false);
      return;
    }
    var html="";
    for(var i=0;i<items.length;i++){
      var p=items[i],src=p.featured_image&&p.featured_image.url||p.image||"";
      html+='<li style="--i:'+i+'"><a href="'+p.url+'"><div class="aspect-[3/4] overflow-hidden rounded-[var(--radius-2xl)] bg-surface-2 shadow-[var(--shadow-soft)]">'+(src?'<img src="'+img(src,500)+'" alt="" loading="lazy" class="h-full w-full object-cover transition-transform duration-700 hover:scale-105">':"")+'</div><p class="item-title mt-3">'+esc(p.title)+'</p><p class="price mt-1 text-primary">'+money(p.price)+"</p></a></li>";
    }
    list.innerHTML=html;
    /* predictive search vraća najviše 10, pa tada ne znamo ukupan broj */
    if(status)status.textContent=items.length<LIMIT?items.length+" "+plural(items.length)+' za "'+q+'"':'Najbolji rezultati za "'+q+'"';
    if(all){all.href=searchUrl(q);show(all,true)}
  }

  function run(q){
    ctrl&&ctrl.abort();
    ctrl=new AbortController();
    Promise.all([suggest(strictQuery(q),ctrl.signal),suggest(q,ctrl.signal)]).then(function(r){
      var seen={},out=[];
      function add(p){if(!seen[p.id]&&out.length<LIMIT){seen[p.id]=1;out.push(p)}}
      function hit(p){return matches(haystack(p),q)}
      /* prvo tačna poklapanja, pa greške u kucanju. Proizvode kod kojih je reč samo
         u opisu ne prikazujemo ("vans" u opisu EA7 šorca, "šorc" u opisu majice). */
      r[0].filter(hit).forEach(add);
      r[1].filter(hit).forEach(add);
      render(out,q);
    }).catch(function(e){"AbortError"!==e.name&&status&&(status.textContent="Pretraga trenutno nije dostupna")});
  }

  input.addEventListener("input",function(){
    var q=cleanQuery(input.value);
    line&&(line.style.transform="scaleX("+(q?1:0)+")");
    timer&&clearTimeout(timer);
    if(q.length<2){ctrl&&ctrl.abort();return reset()}
    timer=setTimeout(function(){run(q)},220);
  });

  document.addEventListener("ow:overlay-close",function(e){
    if(e.detail.name==="search"){input.value="";line&&(line.style.transform="scaleX(0)");reset()}
  });
}

/* ---------- Forme za pretragu: šalju strogi upit ---------- */

function initForms(){
  document.addEventListener("submit",function(e){
    var form=e.target;
    if(!form.matches||!form.matches('form[role="search"]'))return;
    var input=form.querySelector('input[name="q"]');
    if(!input)return;
    var q=cleanQuery(input.value);
    if(!q){e.preventDefault();return}
    e.preventDefault();
    window.location.href=searchUrl(q);
  });
}

/* ---------- Stranica sa rezultatima ---------- */

function initResultsPage(){
  var page=document.querySelector("[data-search-page]");
  if(!page)return;
  var terms=page.getAttribute("data-terms")||"",strict=page.getAttribute("data-strict")==="true",
      count=parseInt(page.getAttribute("data-count"),10)||0,
      params=new URLSearchParams(window.location.search),similar=params.get("slicno")==="1";
  if(!terms)return;
  /* Shopify-jev naslov je na hrvatskom ("pronađen je sljedeći broj rezultata") i sa navodnicima */
  var shop=document.title.split(" – ").pop();
  document.title="Pretraga: "+terms+" – "+shop;
  var base=(OW.routes&&OW.routes.search||"/search")+"?type=product&q=";

  if(!similar){
    /* direktan link bez navodnika (npr. /search?q=boss duks) → strogi upit */
    if(!strict&&!params.get("page")){window.location.replace(base+encodeURIComponent(strictQuery(terms)));return}
    /* nema tačnih rezultata → probaj sa tolerancijom grešaka u kucanju */
    if(count===0){window.location.replace(base+encodeURIComponent(terms)+"&slicno=1");return}
  }

  /* sakrij proizvode koji ne odgovaraju upitu: u režimu "slično" one koje je Shopify
     našao tolerancijom (Hugo za "gucci"), a u strogom one sa rečju samo u opisu */
  var items=page.querySelectorAll("[data-search-item]"),shown=0;
  for(var i=0;i<items.length;i++){
    var ok=matches(items[i].getAttribute("data-hay"),terms);
    items[i].style.display=ok?"contents":"none";
    ok&&shown++;
  }
  var countEl=page.querySelector("[data-search-count]");
  if(similar||shown<items.length)show(countEl,false);
  var note=page.querySelector("[data-search-similar]"),empty=page.querySelector("[data-search-empty]");
  if(shown){similar&&show(note,true)}
  else{
    show(page.querySelector("[data-search-grid]"),false);
    show(empty,true);
  }
  if(similar)page.querySelectorAll("[data-search-nav] a").forEach(function(a){a.href+=(a.href.indexOf("slicno=")===-1?"&slicno=1":"")});
}

function init(){initOverlay();initForms();initResultsPage()}
"loading"===document.readyState?document.addEventListener("DOMContentLoaded",init):init();
}();
